// 2P AI — scheda server (§8.2): semaforo + stato, IP mono, ruolo, riepilogo. `off` attenua la card
// quando la macchina è offline.
import type { ReactNode } from 'react';
import { Icon } from './Icon';
import { ServerSemaforo, type SemaforoState } from './ServerSemaforo';
import { onCardKey } from '../lib/a11y';
import type { Server } from '../lib/types';

export function ServerCard({ server, state, summary, onOpen, onConfig, off }: { server: Server; state: SemaforoState; summary: ReactNode; onOpen: () => void; onConfig?: () => void; off?: boolean }) {
  return (
    <div className={off ? 'card off' : 'card'} role="button" tabIndex={0} onClick={onOpen} onKeyDown={onCardKey(onOpen)}>
      <div className="top">
        <div className="name">{server.name}</div>
        <div className="top-right">
          <ServerSemaforo state={state} />
          {onConfig ? (
            <button type="button" className="cardbtn" title="Configura" aria-label="Configura" onClick={(e) => { e.stopPropagation(); onConfig(); }}>
              <Icon name="settings" />
            </button>
          ) : null}
        </div>
      </div>
      <div className="meta">
        <div className="row"><Icon name="lan" /><span className="ip">{server.host}</span></div>
        <div className="row"><Icon name="dns" />{server.role === 'hub' ? 'Hub principale' : 'Remoto'}{server.cc_version ? ` · CC ${server.cc_version}` : ''}</div>
        {/* Motore indietro: ignora le leve di autonomia, quindi chiede l'OK anche in "Skip totale".
            Senza questa riga il difetto era invisibile — sembrava solo il gate che fa il suo lavoro. */}
        {server.engine_stale_at ? (
          <div className="row warn"><Icon name="update" />Motore da aggiornare: ignora le leve di autonomia</div>
        ) : null}
      </div>
      <div className="foot">
        <span className="sline">{summary}</span>
        <span className="open">Apri<Icon name="arrow_forward" /></span>
      </div>
    </div>
  );
}
